import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { SolicitudDocumentosExViewModel, TDocumentoSolicitudExViewModel } from './documentosEx.types';
import { TipoDocumentacionExViewModel } from '../../../_mantenimiento/general/tipodocumentacionex/tipodocumentacionex.types';

//https://angular.io/tutorial/toh-pt6
//https://malcoded.com/posts/angular-backend-asp-core

@Injectable()
export class DocumentosExService {
    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    //antes se trataba en global.service como una Tc pero ahora requiere recuperar otras columnas adicionales de BD
    getTipoDocumentacionEx(): Observable<TipoDocumentacionExViewModel[]> {
        return this.http.get<TipoDocumentacionExViewModel[]>(this.baseUrl + 'api/mantenimiento/tipodocumentacionex/tiposdocumentacionex').pipe();
    }

    //todos los documentos de una solicitud
    getSolicitudDocumentos(id: number): Observable<SolicitudDocumentosExViewModel> {
        return this.http.get<SolicitudDocumentosExViewModel>(this.baseUrl + 'api/exportacion/documentosEx/' + id).pipe();
    }

    //obtener un documento concreto
    getDocumento(id: number): Observable<TDocumentoSolicitudExViewModel> {
        return this.http.get<TDocumentoSolicitudExViewModel>(this.baseUrl + 'api/exportacion/documentosEx/documento/' + id).pipe();
    }

    //crear un documento, necesita IdSolicitud
    createDocumento(documento: TDocumentoSolicitudExViewModel): Observable<any> {
        return this.http.post<TDocumentoSolicitudExViewModel>(this.baseUrl + 'api/exportacion/documentosEx', documento).pipe();
    }

    editDocumento(documento: TDocumentoSolicitudExViewModel): Observable<any> {
        return this.http.put<TDocumentoSolicitudExViewModel>(this.baseUrl + 'api/exportacion/documentosex', documento).pipe();
    }

    deleteDocumento(id: number): Observable<any> {
        return this.http.delete<TDocumentoSolicitudExViewModel>(this.baseUrl + 'api/exportacion/documentosex/' + id).pipe();
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            //this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }
}
